import { connect } from 'react-redux';
import { getApiRoot, getDisplayCurrentPassword } from '../reducer';
import { updatePassword } from '../actions';
import ChangePasswordForm from './ChangePasswordForm';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var application = _ref.application,
    account = _ref.account,
    user = _ref.user;
  var userIdentity = _ref2.userIdentity;
  return {
    apiRoot: getApiRoot({
      application: application,
      user: user
    }),
    displayCurrentPassword: getDisplayCurrentPassword({
      application: application,
      user: user
    }),
    status: account.status,
    userIdentity: userIdentity
  };
};
var mapDispatchToProps = {
  updatePassword: updatePassword
};
export var ChangePasswordContainer = connect(mapStateToProps, mapDispatchToProps)(ChangePasswordForm);
export default ChangePasswordContainer;